import { ApiSmpArtGallery } from "@smp/api";
import { Await } from "@smp/utils";
import { useInfiniteQuery, useQuery, UseQueryOptions } from "react-query";
import { UseInfiniteQueryOptions } from "react-query/types/react/types";

import { useContextApp } from "@/screens/app/context/app";

const KEY_CANVA = "smp.art_gallery.canva";
const KEY_CRELLO = "smp.art_gallery.crello";
const KEY_UPLOAD = "smp.art_gallery.upload";

export const useSmpArtGalleryCanvaDesignList = (options?: {
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpArtGallery.Canva.list>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    state: { organizationId },
  } = useContextApp();

  const { data, isLoading } = useQuery(
    [KEY_CANVA, { organizationId }],
    ApiSmpArtGallery.Canva.list,
    options?.useQueryOptions,
  );

  return {
    canvaDesignList: data,
    isCanvaDesignListLoading: isLoading,
  };
};

useSmpArtGalleryCanvaDesignList.KEY = KEY_CANVA;

export const useSmpArtGalleryCrelloDesignList = (options?: {
  useQueryOptions?: Omit<
    UseQueryOptions<Await<ReturnType<typeof ApiSmpArtGallery.Crello.list>>>,
    "queryKey" | "queryFn"
  >;
}) => {
  const {
    state: { organizationId },
  } = useContextApp();

  const { data, isLoading } = useQuery(
    [KEY_CRELLO, { organizationId }],
    ApiSmpArtGallery.Crello.list,
    options?.useQueryOptions,
  );

  return {
    crelloDesignList: data,
    isCrelloDesignListLoading: isLoading,
  };
};

useSmpArtGalleryCrelloDesignList.KEY = KEY_CRELLO;

export const useSmpArtGalleryUploadList = (
  params: Parameters<typeof ApiSmpArtGallery.Upload.list>[0],
  options?: Omit<
    UseInfiniteQueryOptions<
      Await<ReturnType<typeof ApiSmpArtGallery.Upload.list>>
    >,
    "queryKey" | "queryFn" | "getNextPageParam"
  >,
) => {
  const {
    state: { organizationId },
  } = useContextApp();

  return useInfiniteQuery<
    Await<ReturnType<typeof ApiSmpArtGallery.Upload.list>>
  >(
    [KEY_UPLOAD, { params, organizationId }],
    ({ pageParam }) => ApiSmpArtGallery.Upload.list(params, pageParam),
    {
      getNextPageParam: (response) => response.next || undefined,
      ...(options || {}),
    },
  );
};

useSmpArtGalleryUploadList.KEY = KEY_UPLOAD;
